export class OrganizationModel {

  _id: string;
  name: string;
  country: string;
  isInternational: boolean;
  schoolIds: string[];
  createdAt: string;
  updatedAt: string;

  static generate(data: any): OrganizationModel {
    const m = new OrganizationModel();
    if (!data) {
      return m;
    }
    m._id             = data._id;
    m.name            = data.name;
    m.country         = data.country;
    m.isInternational = data.isInternational;
    m.schoolIds       = data.schoolIds || [];
    m.createdAt       = data.createdAt;
    m.updatedAt       = data.updatedAt;
    return m;
  }

  static generateList(data: any[]): OrganizationModel[] {
    if (!data) {
      return [];
    }
    return data.map(d => OrganizationModel.generate(d));
  }
}

export class OrganizationFilter {
  name: string = undefined;
  sortByName: 1 | -1 = 1;
  skip = 0;
  limit: number = undefined;
}

export class SaveOrganizationPayload {
  _id: string = undefined;
  name: string;
  country: string;
}
